import { useEffect, useState } from 'react';

import { ButtonComponent } from '../../../../components/ButtonComponen';
import { CalendarComponent } from '../../../../components/CalendarComponent';
import { useDeviceTypesCatalogs } from '../../../../hooks/catalogs/useDeviceTypesCatalogs';
import { RiFileExcel2Line } from 'react-icons/ri';
import { ContainerItem } from '../../../../components';
import { DropdownComponent } from '../../../../components/DropdownComponen';
import { useHistoryDevice } from '../../../../hooks/historyDevice/useHistoryDevice';
import { ToastComponent } from '../../../../components/ToastComponent';
import { IoIosSearch } from 'react-icons/io';
import { TbFilterOff } from 'react-icons/tb';
import { IDevice } from '../../../../interfaces/interfaceHistoryDevice';

export const Filters = () => {
  const { getDeviceTypesCatalog } = useDeviceTypesCatalogs();
  const { getHistoryDevice, historyDeviceExcel } = useHistoryDevice();

  const [selectedDeviceType, setSelectedDeviceType] = useState(null);

  const [devices, setDevices] = useState<IDevice[]>([]);
  const [fromDate, setFromDate] = useState<string>('');
  const [toDate, setToDate] = useState<string>('');
  const [fromDateInput, setFromDateInput] = useState<string>('');
  const [toDateInput, setToDateInput] = useState<string>('');

  //hooks
  const getDeviceType = async () => {
    let response = await getDeviceTypesCatalog();
    if (response.status === 200) {
      const options = response.data.message.map((_device: any) => ({
        label: _device.name,
        value: _device.deviceTypeId,
      }));
      setDevices(options);
    }
  };

  useEffect(() => {
    getDeviceType();
  }, []);

  const validateDates = (): boolean => {
    if (!fromDate || !toDate) {
      ToastComponent(
        'warning',
        '',
        'Debes seleccionar ambas fechas: inicial y final.',
        3000
      );
      return false;
    }

    const from = new Date(fromDate);
    const to = new Date(toDate);

    if (from > to) {
      ToastComponent(
        'warning',
        '',
        'La fecha inicial no puede ser mayor que la fecha final.',
        3000
      );
      return false;
    }

    return true;
  };

  const handleExcel = async () => {
    if (!validateDates()) return;
    let queryString = '?';
    queryString += `&initialDate=${fromDate}`;
    queryString += `&finalDate=${toDate}`;

    return await historyDeviceExcel(queryString);
  };

  const handlerFilters = (queryRequest: string) => {
    let query = `?${queryRequest}`;
    getHistoryDevice(query);
  };

  const sendData = () => {
    if (!validateDates()) return;

    let queryRequest = '';

    if (selectedDeviceType !== '' && selectedDeviceType !== null) {
      queryRequest += `&deviceTypeId=${selectedDeviceType}`;
    }

    queryRequest += `&initialDate=${fromDate}`;
    queryRequest += `&finalDate=${toDate}`;

    handlerFilters(queryRequest);
  };

  function cleanFilters() {
    setFromDate('');
    setFromDateInput('');
    setToDate('');
    setToDateInput('');
    setSelectedDeviceType(null);
  }

  const renderFromDate = () => {
    return (
      <ContainerItem>
        <CalendarComponent
          name={'fromDate'}
          maxDate={new Date()}
          onChange={(e: any) => {
            const selectedFromDate = e.value;

            if (selectedFromDate) {
              setFromDateInput(selectedFromDate);

              const day = String(selectedFromDate.getDate()).padStart(2, '0');
              const month = String(selectedFromDate.getMonth() + 1).padStart(
                2,
                '0'
              );
              const year = selectedFromDate.getFullYear();
              const formattedDate = `${year}-${month}-${day}`;
              setFromDate(formattedDate);
            } else {
              setFromDateInput('');
              setFromDate('');
            }
          }}
          value={fromDateInput}
          placeholder="Fecha inicial"
          className=" h-12"
        />
      </ContainerItem>
    );
  };

  const renderToDate = () => {
    return (
      <ContainerItem>
        <CalendarComponent
          name={'toDate'}
          maxDate={new Date()}
          onChange={(e: any) => {
            const selectedToDate = e.value;
            if (selectedToDate) {
              if (fromDateInput && selectedToDate < new Date(fromDateInput)) {
                setToDate(fromDateInput);
                setToDateInput(fromDateInput);
                ToastComponent(
                  'warning',
                  '',
                  'La fecha final no puede ser menor que la fecha inicial',
                  3000
                );
                return;
              } else {
                setToDateInput(selectedToDate);
                const day = String(selectedToDate.getDate()).padStart(2, '0');
                const month = String(selectedToDate.getMonth() + 1).padStart(
                  2,
                  '0'
                );
                const year = selectedToDate.getFullYear();
                const formattedDate = `${year}-${month}-${day}`;
                setToDate(formattedDate);
              }
            } else {
              setToDateInput('');
              setToDate('');
            }
          }}
          value={toDateInput}
          placeholder="Fecha final"
          className=" h-12"
        />
      </ContainerItem>
    );
  };

  const buttonsActions = () => {
    return (
      <div className="flex w-full h-full col-span-2 col-start-6 justify-end items-center gap-2 px-3">
        <ButtonComponent
          icon={<IoIosSearch />}
          onClick={() => sendData()}
          className="p-button-rounded  p-button-md"
          name="search"
        />
        <ButtonComponent
          icon={<TbFilterOff />}
          onClick={() => cleanFilters()}
          className="p-button-rounded p-button-md"
          name="clear"
        />
        <ButtonComponent
          icon={<RiFileExcel2Line />}
          onClick={async () => {
            handleExcel();
          }}
          className="p-button-rounded p-button-md"
          name="export"
        />
      </div>
    );
  };

  const renderSelectDeviceType = () => {
    return (
      <ContainerItem>
        <DropdownComponent
          placeholder="Selecciona un tipo"
          options={devices}
          optionLabel="label"
          optionValue="value"
          value={selectedDeviceType}
          onChange={(e: any) => setSelectedDeviceType(e.value)}
          className="w-full"
          filter={true}
        />
      </ContainerItem>
    );
  };

  return (
    <div className="flex w-full h-full relative flex-row bg-white rounded-b-lg shadow-lg">
      <div className="grid grid-cols-6   w-full">
        {renderFromDate()}
        {renderToDate()}
        {renderSelectDeviceType()}
        {buttonsActions()}
      </div>
    </div>
  );
};
